import * as React from "react"

const ContactUsIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.35 103.8" {...props}>
    <title>{"Contact-Us-ShipX-2"}</title>
    <path
      d="M94.38 103.8H10l-10-10V82.06h104.35v11.77Zm-82.61-4.35h80.81l7.42-7.42v-5.58H4.35v5.62Z"
      fill="#3e4c5e"
    />
    <path
      fill="#3e4c5e"
      d="M100 86.41H4.35V12.49h23.48v4.35H8.7v65.22h86.95V16.84H76.52v-4.35H100v73.92zM63 95.1h-4.3v-4.35H63Zm-8.69 0H50v-4.35h4.35Zm-8.7 0H41.3v-4.35h4.35Z"
    />
    <path
      d="M77.17 53.8h-3.26V29.88h3.26a12 12 0 0 1 0 23.92Zm1.09-19.49v15.07a7.61 7.61 0 0 0 0-15.07ZM30.43 53.8h-3.26a12 12 0 0 1 0-23.92h3.26Zm-4.34-19.49a7.61 7.61 0 0 0 0 15.07Z"
      fill="#3e4c5e"
    />
    <path
      d="M83.7 33.15h-4.35v-2.18a27.18 27.18 0 0 0-54.35 0v2.18h-4.35v-2.18a31.53 31.53 0 0 1 63.05 0ZM84.78 64.67H63.04v-4.35h17.4V49.89h4.34v14.78z"
      fill="#3e4c5e"
    />
    <path
      d="M58.7 69.01h-6.53a6.52 6.52 0 0 1-1-13 5.79 5.79 0 0 1 1 0h6.53a6.52 6.52 0 0 1 0 13Zm-6.53-8.69a2.18 2.18 0 0 0 0 4.35h6.53a2.18 2.18 0 0 0 0-4.35Z"
      fill="#3e4c5e"
    />
    <path
      fill="#b9d816"
      d="M67.39 21.19v21.74H55.22l-11.74 6.52v-6.52h-6.52V21.19h30.43z"
    />
  </svg>
)

export default ContactUsIcon
